// extracted by mini-css-extract-plugin
export default {"resetPassword":"styles_resetPassword__6PuRQ","resetPasswordContainer":"styles_resetPasswordContainer__3DMf7","buttonGroup":"styles_buttonGroup__w9+Wk"};